/*
 Import all product specific js
 */
import $ from 'jquery';
import PageManager from '../page-manager';
import Review from './product/reviews';
import collapsibleFactory from './common/collapsible';
import ProductDetails from './common/product-details';
import videoGallery from './product/video-gallery';
import { classifyForm } from './common/form-utils';

export default class Product extends PageManager {
    constructor() {
        super();
        this.url = location.href;
        this.$reviewLink = $('[data-reveal-id="modal-review-form"]');
    }

    before(next) {
        // Listen for foundation modal close events to sanitize URL after review.
        $(document).on('close.fndtn.reveal', () => {
            if (this.url.indexOf('#writeReview') !== -1 && typeof window.history.replaceState === 'function') {
                window.history.replaceState(null, document.title, window.location.pathname);
            }
        });

        next();
    }

    loaded(next) {
        let validator;

        // Init collapsible
        collapsibleFactory();

        this.productDetails = new ProductDetails($('.productView'), this.context, window.BCData.product_attributes);

        videoGallery();

        const $reviewForm = classifyForm('.writeReview-form');
        const review = new Review($reviewForm);

        $('body').on('click', '[data-reveal-id="modal-review-form"]', () => {
            validator = review.registerValidation();
        });

        $reviewForm.on('submit', () => {
            if (validator) {
                validator.performCheck();
                return validator.areAll('valid');
            }

            return false;
        });

        next();
    }

    after(next) {
        this.productReviewHandler();

        next();
    }

    productReviewHandler() {
        if (this.url.indexOf('#writeReview') !== -1) {
            this.$reviewLink.click();
        }
    }
}

var originalImages = '';
var CurrentProdThumbImage = 0;
var ShowVariationThumb =false;
var ProductThumbWidth = 500;
var ProductThumbHeight =  659;
var ProductMaxZoomWidth = 1280;
var ProductMaxZoomHeight =  1280;
var ProductTinyWidth = 60;
var ProductTinyHeight =  79;
$(document).ready(function(){
	$("#openImage").fancybox({
		'transitionIn'		: 'none',
		'transitionOut'		: 'none',
		'titlePosition' 	: 'over',
		'titleFormat'       : function(title, currentArray, currentIndex, currentOpts) {
		    //return '<span id="fancybox-title-over">Image ' +  (currentIndex + 1) + ' / ' + currentArray.length + ' ' + title + '</span>';
		}
	});
	
	$('.fancybox').fancybox({
		'transitionIn'		: 'none',
		'transitionOut'		: 'none',
		'titlePosition' 	: 'over',
		'titleFormat'       : function(title, currentArray, currentIndex, currentOpts) {
		    //return '<span id="fancybox-title-over">Image ' +  (currentIndex + 1) + ' / ' + currentArray.length + ' ' + title + '</span>';
		}
	});
	
	/*$("#openImage").click(function(e){
		e.preventDefault();
		var TargetedImage = $(this).attr("data-tid");
		var pid = $(this).attr("data-id");
		var currentImage=0;
		if(TargetedImage) {
			currentImage = TargetedImage;
		} else if(CurrentProdThumbImage!='undefined'){
			currentImage = CurrentProdThumbImage;
		}
		if(ShowVariationThumb) {
			var url = "http://192.168.52.15:3000/productimage.php?product_id="+pid+"&image_rule_id=" + encodeURIComponent(ShowVariationThumb);
		} else {
			var url = "http://192.168.52.15:3000/productimage.php?product_id="+pid+"&current_image="+currentImage;
		}
		
		$('.iframe').attr("href", url);

		//$('.iframe').click();
		
		var w = $(window).width();
		var h = $(window).height();
		
		// tiny image box width plus 3 px margin, times the number of tiny images, plus the arrows width
		var carouselWidth = (64 + 3) * Math.min(10, 5) + 70;
	
		//the width of the prev and next link
		var navLinkWidth = 250;
	
		var requiredNavWidth = Math.max(carouselWidth, navLinkWidth);
	
		// calculate the width of the widest image after resized to fit the screen.
		// 200 is the space betewn the window frame and the light box frame.
		var wr = Math.min(w-200, 1280) / 1280;
		var hr = Math.min(h-200, 1280) / 1280;
	
		var r = Math.min(wr, hr);
	
		var imgResizedWidth = Math.round(r * 1280);
		var imgResizedHeight = Math.round(r * 1280);
	
		//calculate the width required for lightbox window
		var horizontalPadding = 100;
		var width = Math.min(w-100, Math.max(requiredNavWidth, imgResizedWidth+ horizontalPadding));
		var height = h-100;
		
		$.fancybox.open({
			'frameWidth'	: 800,
			'frameHeight'	: 700,
			'width'	: 800,
			'height'	: 700,
			'href': url,
			type: 'iframe'
		});
	});*/
});

/*$(document).ready(function() { 
	var i = 0;
	$(".productView-thumbnail").each(function(){
		$(this).find("a").attr("data-tid", i);
		//$(this).find("a").attr("onclick", 'showProductImageLightBox('+i+', "{{product.id}}"); return false;');
		i++;
	})
	originalImages = $('#LightBoxImages').html(); 
	//initProductLightBox();
});*/


// WEBPACK FOOTER //
// ./assets/js/theme/product.js